<template>
  <footer class="flex justify-center px-3 pt-2">
    <a
      href="https://github.com/gqgs/3x3-generator"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open GitHub repository"
      class="inline-flex min-h-9 items-center gap-2 rounded-lg px-3 text-xs font-semibold uppercase tracking-[0.16em] text-slate-500 hover:bg-white/55 hover:text-slate-800"
    >
      <ion-icon class="text-base" name="logo-octocat"></ion-icon>
      <span>GitHub</span>
    </a>
  </footer>
</template>
